import './mision.css';
import imgMision from '../assets/images/mision.png'; // cambia por la tuya

function Mision() {
  return (
    <section className="mision">
      <div className="mision-container">

        <div className="mision-text">
          <h2>MISIÓN</h2>
          <p>
            Producir y comercializar productos industriales de alta
            calidad, generando valor económico y social.
          </p>

          <button>Ver Más</button>
        </div>

        <div className="mision-img">
          <img src={imgMision} alt="Misión" />
        </div>

      </div>
    </section>
  );
}

export default Mision;